import Entity from 'lib/Entity';

export default class Avatar extends Entity {
  parse(response: any): any {
    const parsed = Object.assign({}, response);

    if (response.svgUrl) {
      parsed['svg_url'] = response.svgUrl;
    }

    return parsed;
  }

  getColor() {
    return this.get('color');
  }

  getUrl() {
    // file_url is a PNG version which we don't use on web anymore.
    return this.get('svg_url');
  }
}
